import { useRouter } from 'next/router';
import { useCappsApplicationsWebApiHandler_startApplication } from '@zg-rentals/ts-capps-client-react-query';
import { useEffect } from 'react';
import { TallHeightLoadingMask } from '../../styles/css-components';
import { getEditRoute } from '../../constants/urls';
import { logError } from '@zg-rentals/log-error';
import { REQUESTING_CLIENT } from '../../constants/api';
import { getZgBrand } from '../../constants/brands';

export function ApplicationCreate() {
  const router = useRouter();
  const { listingAlias, utm_source, utm_medium, utm_guid, utm_campaign } = router.query;

  const utmGuid = String(utm_guid ?? '');
  const utmCampaign = String(utm_campaign ?? '');
  const utmMedium = String(utm_medium ?? '');
  const utmSource = String(utm_source ?? '');
  const referrerBrand = getZgBrand(utmSource);

  const startApplicationMutation = useCappsApplicationsWebApiHandler_startApplication({
    meta: { context: { api: 'cappsApplications', details: 'startApplication' } },
  });

  async function startApplication() {
    try {
      const response = await startApplicationMutation.mutateAsync({
        postData: {
          listingAlias: String(listingAlias ?? ''),
          requestingClient: REQUESTING_CLIENT,
          utmSource,
          utmMedium,
          utmGuid,
          utmCampaign,
          referrerBrand,
        },
      });
      const applicationId = response.applicationId;
      if (applicationId) {
        router.push(getEditRoute({ applicationId }));
      }
    } catch (err) {
      logError({ error: err, context: 'ApplicationCreate - useStartApplication hook error' });
      router.push('/');
    }
  }

  useEffect(() => {
    if (listingAlias) {
      startApplication();
    }
  }, [listingAlias]);

  return (
    <TallHeightLoadingMask>
      <></>
    </TallHeightLoadingMask>
  );
}
